import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1e9a10b6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "loan-collapse"
};
const _hoisted_2 = {
  class: "loan-collapse-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "FAQ", -1));
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "more-question"
};
const _hoisted_6 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item");
  const _component_el_collapse = _resolveComponent("el-collapse");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_collapse, {
    modelValue: $setup.activeName,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.activeName = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($setup.QUESTIONS), (item, index) => {
      return _openBlock(), _createBlock(_component_el_collapse_item, {
        key: index,
        title: `Q${index + 1}.${$setup.t($setup.QUESTIONS[index + 1].title)}`,
        name: `${index + 1}`,
        onClick: $event => $setup.handleClick(index + 1)
      }, {
        default: _withCtx(() => [_createElementVNode("p", {
          innerHTML: $setup.t($setup.QUESTIONS[index + 1].content, {
            url: $setup.replaceDomainToLocation(`https://blog.bybit.com${$setup.replace($setup.QUESTIONS[index + 1].link)}`)
          })
        }, null, 8, _hoisted_4)]),
        _: 2
      }, 1032, ["title", "name", "onClick"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("p", _hoisted_5, [_createElementVNode("a", {
    href: $setup.noDmainUrl($setup.replace('/help-center/bybitHC_Article?id=000001770')),
    target: "_blank"
  }, _toDisplayString($setup.t('more')), 9, _hoisted_6)])])]);
}